/* Bandeau cookies Maison Ronron (préfixe ck) : interface sur l'API Customer Privacy de Shopify.
   - Charge l'API (Shopify.loadFeatures 'consent-tracking-api'), affiche le bandeau si shouldShowBanner().
   - Tout accepter / Tout refuser / Personnaliser (préférences, mesure d'audience, publicité) → setTrackingConsent.
   - Tout élément [data-ck-ouvrir] (lien « Gérer les cookies » du pied de page) rouvre les réglages, pré-remplis
     avec les choix déjà enregistrés (currentVisitorConsent).
   - Quand le bandeau est prêt, html.ck-actif masque celui de Shopify (voir mr14-cookies.css). */
(function () {
  'use strict';
  const racine = document.querySelector('[data-ck]');
  if (!racine) return;
  const $ = (s) => racine.querySelector(s);
  const carte = $('[data-ck-carte]');
  const prefs = $('[data-ck-prefs]');
  const perso = $('[data-ck-perso]');
  const enregistrer = $('[data-ck-enregistrer]');
  const refuser = $('[data-ck-refuser]');
  const accepter = $('[data-ck-accepter]');
  const annonce = $('[data-ck-annonce]');
  const reduit = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  let api = null;
  let ouvertPar = null;

  function charger(fn) {
    const S = window.Shopify;
    if (S && S.customerPrivacy) return fn(S.customerPrivacy);
    if (!S || typeof S.loadFeatures !== 'function') return; // hors Shopify : on laisse le bandeau Shopify
    S.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (err) => {
      if (!err && window.Shopify.customerPrivacy) fn(window.Shopify.customerPrivacy);
    });
  }

  function remplir() {
    let c = {};
    try { c = (api && api.currentVisitorConsent && api.currentVisitorConsent()) || {}; } catch (e) { c = {}; }
    ['preferences', 'analytics', 'marketing'].forEach((k) => {
      const box = prefs.querySelector(`[name="${k}"]`);
      if (box) box.checked = c[k] === 'yes'; // aucune case précochée sans accord explicite
    });
  }

  function montrer(avecPrefs) {
    racine.hidden = false;
    racine.classList.remove('ck-sort', 'ck-croque');
    racine.classList.add('ck-entre');
    ouvrirPrefs(!!avecPrefs);
    requestAnimationFrame(() => { (avecPrefs ? prefs.querySelector('input') : carte).focus({ preventScroll: true }); });
  }

  function ouvrirPrefs(oui) {
    prefs.hidden = !oui;
    enregistrer.hidden = !oui;
    perso.hidden = oui;
    perso.setAttribute('aria-expanded', oui ? 'true' : 'false');
    racine.classList.toggle('ck-ouvre', oui);
    if (oui) remplir();
  }

  function fermer(croque) {
    const fin = () => {
      racine.hidden = true;
      racine.classList.remove('ck-entre', 'ck-sort', 'ck-croque', 'ck-ouvre');
      racine.querySelectorAll('.ck-morsure').forEach((c) => c.setAttribute('r', '0'));
      if (ouvertPar && document.contains(ouvertPar)) ouvertPar.focus({ preventScroll: true });
      ouvertPar = null;
    };
    if (reduit) { racine.classList.add('ck-sort'); setTimeout(fin, 220); return; }
    if (croque) {
      racine.classList.add('ck-croque');
      // deux coups de dent dans le biscuit (attribut r : plus fiable que la propriété CSS dans un masque SVG)
      racine.querySelectorAll('.ck-morsure').forEach((c, i) => setTimeout(() => c.setAttribute('r', i ? '8' : '11'), 40 + i * 170));
    }
    racine.classList.add('ck-sort');
    setTimeout(fin, croque ? 980 : 540);
  }

  function envoyer(choix, croque, message) {
    const fini = () => { annonce.textContent = message; fermer(croque); };
    try { api.setTrackingConsent(choix, fini); } catch (e) { fini(); }
  }

  accepter.addEventListener('click', () => envoyer({ preferences: true, analytics: true, marketing: true }, true, 'Cookies acceptés.'));
  refuser.addEventListener('click', () => envoyer({ preferences: false, analytics: false, marketing: false }, false, 'Cookies refusés.'));
  perso.addEventListener('click', () => ouvrirPrefs(true));
  enregistrer.addEventListener('click', () => {
    const v = (k) => !!prefs.querySelector(`[name="${k}"]`).checked;
    envoyer({ preferences: v('preferences'), analytics: v('analytics'), marketing: v('marketing') }, v('marketing') && v('analytics'), 'Vos choix de cookies sont enregistrés.');
  });
  racine.addEventListener('keydown', (e) => {
    // Échap : ferme les réglages rouverts depuis le pied de page (au premier passage, un choix reste demandé)
    if (e.key === 'Escape' && ouvertPar) fermer(false);
  });

  document.addEventListener('click', (e) => {
    const lien = e.target.closest && e.target.closest('[data-ck-ouvrir]');
    if (!lien || !api) return;
    e.preventDefault();
    ouvertPar = lien;
    montrer(true);
  });

  charger((cp) => {
    api = cp;
    document.documentElement.classList.add('ck-actif');
    document.querySelectorAll('[data-ck-ouvrir]').forEach((a) => { a.hidden = false; });
    let afficher = false;
    try { afficher = !!cp.shouldShowBanner() && !['preferences', 'analytics', 'marketing'].some((k) => { const v = (cp.currentVisitorConsent() || {})[k]; return v === 'yes' || v === 'no'; }); } catch (e) { afficher = false; }
    if (afficher) setTimeout(() => montrer(false), 600); // laisse la page s'afficher d'abord
  });

  // Aperçu dans l'éditeur de thème (ou ?ck=apercu) : bandeau affiché pour régler son apparence
  if ((window.Shopify && window.Shopify.designMode) || /[?&]ck=apercu\b/.test(location.search)) {
    setTimeout(() => { if (racine.hidden) montrer(false); }, 600);
  }
})();
